import { createClearStreamDataAction } from 'widgets/store/stream/actions';
import { WidgetType } from 'widgets/WidgetType';

export const clearPlCapsuleDataAction = createClearStreamDataAction(
    WidgetType.PL_CAPSULE
);
